/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SendEmailDocumentViewModel } from "../types/SendEmailDocumentViewModel.ts";
import { eDocumentTypeSchema } from "./eDocumentTypeSchema.ts";

export const sendEmailDocumentViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da matrícula do aluno para quem o documento será enviado por e-mail.",
      ),
  ),
  documentType: z.optional(
    z
      .lazy(() => eDocumentTypeSchema)
      .describe(
        "0 = CourseDocument | 1 = Syllabus | 2 = Contract | 3 = Manual | 4 = MonographDefense | 5 = FinishCourseCertificate | 6 = UspDocument | 7 = Regiment | ",
      ),
  ),
  documentId: z
    .number()
    .int()
    .describe("ID do documento específico a ser enviado. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura do idioma do documento (ex: pt-BR, en-US). Padrão: pt-BR.",
    )
    .nullish(),
}) as unknown as ToZod<SendEmailDocumentViewModel>;
